// Authentication utilities
import { signOutFromGoogle } from './googleAuth';

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

export const logout = () => {
  removeToken();
  // Sign out from Google as well
  signOutFromGoogle();
  window.location.href = '/login';
};